var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPercentage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "10088 802 22 20.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-4 {\n        fill: #2400ff;\n      }\n\n      .cls-2 {\n        fill: none;\n      }\n\n      .cls-3, .cls-4 {\n        stroke: none;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_281",
    "data-name": "Group 281",
    transform: "translate(8873 178)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_264",
    "data-name": "Group 264",
    transform: "translate(1221.25 630.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "discount"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_86",
    "data-name": "Path 86",
    className: "cls-1",
    d: "M30.851,23.4,22.9,31.355a.5.5,0,1,0,.695.695L31.546,24.1a.5.5,0,0,0-.7-.7Z",
    transform: "translate(-22.696 -23.252)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87",
    "data-name": "Path 87",
    className: "cls-1",
    d: "M24.757,26.513A1.757,1.757,0,1,0,23,24.757,1.757,1.757,0,0,0,24.757,26.513Zm0-2.519a.762.762,0,1,1-.762.762.779.779,0,0,1,.762-.762Z",
    transform: "translate(-22.949 -23)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88",
    "data-name": "Path 88",
    className: "cls-1",
    d: "M57.557,55.8a1.757,1.757,0,1,0,1.757,1.757A1.757,1.757,0,0,0,57.557,55.8Zm0,2.519a.762.762,0,1,1,.762-.762A.779.779,0,0,1,57.557,58.319Z",
    transform: "translate(-50.313 -50.365)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Path_8",
    "data-name": "Path 8",
    className: "cls-2",
    transform: "translate(1215 624)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M5.5,0h11A5.5,5.5,0,0,1,22,5.5v9.9a5.5,5.5,0,0,1-5.5,5.5H5.5A5.5,5.5,0,0,1,0,15.4V5.5A5.5,5.5,0,0,1,5.5,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M 16.5 19.89999961853027 C 18.98130989074707 19.89999961853027 21 17.88130950927734 21 15.39999961853027 L 21 5.5 C 21 3.018689870834351 18.98130989074707 0.9999998211860657 16.5 0.9999998211860657 L 5.5 0.9999998211860657 C 3.01869010925293 0.9999998211860657 1 3.018689870834351 1 5.5 L 1 15.39999961853027 C 1 17.88130950927734 3.01869010925293 19.89999961853027 5.5 19.89999961853027 L 16.5 19.89999961853027 M 16.5 20.89999961853027 L 5.5 20.89999961853027 C 2.462430000305176 20.89999961853027 -1.77635683940025e-15 18.43757057189941 -1.77635683940025e-15 15.39999961853027 L -1.77635683940025e-15 5.5 C -1.77635683940025e-15 2.462429761886597 2.462430000305176 -1.907348661234209e-07 5.5 -1.907348661234209e-07 L 16.5 -1.907348661234209e-07 C 19.53757095336914 -1.907348661234209e-07 22 2.462429761886597 22 5.5 L 22 15.39999961853027 C 22 18.43757057189941 19.53757095336914 20.89999961853027 16.5 20.89999961853027 Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPercentage);
export default __webpack_public_path__ + "static/media/percentage.2cb6f8d324513e7cfb14ff6a1aed602e.svg";
export { ForwardRef as ReactComponent };